import React from "react";
import { useStateContext } from "../contexts/ContextProvider";
import { homeTypes } from "../data/dummyData";

const PropertyTypeForm = () => {
  const { address, handleAddress, errorAnimation } = useStateContext();

  return (
    <>
      <div className={`mt-5 ${errorAnimation.homeType}`}>Property Type:</div>
      <form className="my-5">
        <ul className="grid grid-cols-3 gap-3">
          {homeTypes.map((item, index) => {
            return (
              <label
                key={item.id}
                className={`grid justify-items-center text-snappily-orange hover:border-snappily-orange 
                ${
                  address.homeType === item.name
                    ? `border-snappily-orange`
                    : `border-gray-300`
                } border-2 rounded-lg`}
              >
                <input
                  id={`home-type-${index}`}
                  name="homeType"
                  type="radio"
                  value={item.name}
                  checked={address.homeType === item.name ? true : false}
                  onChange={handleAddress}
                  className="m-2 h-5"
                />
                <div
                  className={
                    item.name === "tiny house" ? `text-2xl` : "text-4xl"
                  }
                >
                  {item.icon}
                </div>
                <div className="text-lg p-1">
                  {item.name[0].toUpperCase() + item.name.slice(1)}
                </div>
              </label>
            );
          })}
        </ul>
      </form>
    </>
  );
};

export default PropertyTypeForm;
